// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"zn-z","slideIn":"An-z"};